import {Component, EventEmitter, Output} from "@angular/core";
import {DeviceService} from "../device.service";

@Component({
	selector: "ignore-database",
	template: `
		<modal *ngIf="isModalVisible" (close)="onModalClosed()">
			<header class="modal_header">
				<h1>Ignore Database?</h1>
			</header>
			<div class="modal_body">
				<div class="modal-dialog-centered">
					This database has expired and you have not purchased additional updates.

					If you no longer use this database and would like to remove it from being displayed in
					flyGarmin and Garmin Pilot, click the Ignore Database button below.

				</div>
			</div>
			<div class="modal_footer">
				<button class="button" (click)="onModalClosed()">
					CANCEL
				</button>
				<button class="button button-primary" (click)="onClickIgnore()">
					IGNORE DATABASE
				</button>
			</div>
		</modal>
	`,
})
export class IgnoreDatabaseComponent {
	@Output() modalClosed = new EventEmitter();
	isModalVisible: boolean = false;
	deviceId: number;
	seriesId: number;
	service: DeviceService;

	open(deviceService: DeviceService, deviceId: number, seriesId: number) {
		this.isModalVisible = true;
		this.deviceId = deviceId;
		this.seriesId = seriesId;
		this.service = deviceService;
	}

	onClickIgnore() {
		this.service.ignoreDatabase(this.deviceId, this.seriesId).subscribe(response => {
			if (response.status === 200) {
				this.onModalClosed()
				window.location.reload();
			} else {
				throw response;
			}
		});
	}

	onModalClosed() {
		this.isModalVisible = false;
		this.modalClosed.emit();
	}
}
